export default __webpack_public_path__ + "media/src/usersite/images/footer/home-532d07a694bbb79006cb3acebaefc146.png";